
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconGrid9DotsSelector = "fhi-icon-grid-9-dots";

/**
 * ## FhiIconGrid9Dots
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-grid-9-dots
 * @element fhi-icon-grid-9-dots
 */
@customElement(FhiIconGrid9DotsSelector)
export class FhiIconGrid9Dots extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path fill-rule="evenodd" d="M5 6.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m7 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m7 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m-14 7a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m7 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m7 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m-14 7a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m7 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m7 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5" clip-rule="evenodd"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
